import { a as n, b as g, n as r, t as p } from "./element-CV9utnHJ.js";
var o = Object.defineProperty, c = Object.getOwnPropertyDescriptor, a = (e, l, t, h) => {
  for (var i = h > 1 ? void 0 : h ? c(l, t) : l, d = e.length - 1, u; d >= 0; d--)
    (u = e[d]) && (i = (h ? u(l, t, i) : u(i)) || i);
  return h && i && o(l, t, i), i;
};
let s = class extends n {
  constructor() {
    super(...arguments), this.size = void 0, this.level = 2, this.weight = void 0, this.visuallyHidden = !1, this.align = void 0;
  }
  connectedCallback() {
    super.connectedCallback(), this.setAttribute("role", "heading"), this.setAttribute("aria-level", String(this.level)), this.updateHostClasses();
  }
  attributeChangedCallback(e, l, t) {
    super.attributeChangedCallback(e, l, t), e === "level" && t && this.setLevel(Number(t)), e === "visuallyHidden" && (this.visuallyHidden = t !== null && t !== "false"), (e === "size" || e === "visuallyHidden" || e === "align" || e === "weight") && this.updateHostClasses();
  }
  updated(e) {
    super.updated(e), e.has("level") && (this.setLevel(this.level), this.hasAttribute("size") || (this.size = this.defaultSizeForLevel), this.hasAttribute("weight") || (this.weight = this.defaultWeightForLevel)), !this.hasAttribute("size") && (e.has("level") || this.size === void 0) && (this.size = this.defaultSizeForLevel), (e.has("size") || e.has("visuallyHidden") || e.has("align") || e.has("weight")) && this.updateHostClasses();
  }
  setLevel(e) {
    e >= 1 && e <= 6 ? (this.level = e, this.setAttribute("aria-level", String(e))) : console.warn(`Invalid heading level: ${e}. Must be between 1 and 6.`);
  }
  get defaultSizeForLevel() {
    switch (this.level) {
      case 1:
        return "xlarge";
      case 2:
        return "large";
      case 3:
        return "medium";
      case 4:
        return "small";
      case 5:
        return "xsmall";
      case 6:
        return "xsmall";
      default:
        return "medium";
    }
  }
  get defaultWeightForLevel() {
    switch (this.level) {
      case 1:
        return "regular";
      case 2:
        return "regular";
      case 3:
        return "medium";
      case 4:
        return "medium";
      case 5:
        return "medium";
      case 6:
        return "medium";
      default:
        return "medium";
    }
  }
  updateHostClasses() {
    this.classList.remove(
      "pkt-heading",
      "pkt-heading--xsmall",
      "pkt-heading--small",
      "pkt-heading--medium",
      "pkt-heading--large",
      "pkt-heading--xlarge",
      "pkt-sr-only",
      "pkt-heading--start",
      "pkt-heading--center",
      "pkt-heading--end",
      "pkt-heading--light",
      "pkt-heading--regular",
      "pkt-heading--medium",
      "pkt-heading--bold"
    ), this.classList.add("pkt-heading"), this.size && this.classList.add(`pkt-heading--${this.size}`), this.weight && this.classList.add(`pkt-heading--fw-${this.weight}`), this.visuallyHidden && this.classList.add("pkt-sr-only"), this.align && this.classList.add(`pkt-heading--${this.align}`);
  }
  render() {
    return g`<slot></slot>`;
  }
};
a([
  r({ type: String, reflect: !0 })
], s.prototype, "size", 2);
a([
  r({ type: Number, reflect: !0 })
], s.prototype, "level", 2);
a([
  r({ type: String, reflect: !0 })
], s.prototype, "weight", 2);
a([
  r({ type: Boolean, reflect: !0 })
], s.prototype, "visuallyHidden", 2);
a([
  r({ type: String, reflect: !0 })
], s.prototype, "align", 2);
s = a([
  p("pkt-heading")
], s);
export {
  s as P
};
